function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
 *  Desktop Menu
 *    Scripts the desktop meganav menu
 *
 *  Version:
 *    1.0.0 - 2020/02/24
 */

import { HEADER_INNER } from "../../sections/header/Header";
export var DESKTOP_MENU_SELECTOR = '[data-desktop-menu]';
export var DESKTOP_MENU_TRIGGER = 'data-desktop-menu-trigger';
export var DESKTOP_MENU_SUBMENU = 'data-desktop-menu-submenu';
export var DESKTOP_SUBMENU_CONTAINER = '[data-desktop-subsubmenu-container]';
export var DESKTOP_SUBMENU_TRIGGER = 'data-desktop-submenu-trigger';
export var DESKTOP_SUBSUBMENU_CONTENT = 'data-desktop-subsubmenu';
export var DESKTOP_SUBSUBMENU_CONTENT_TRIGGER = 'data-desktop-submenu-image-trigger';
export var DESKTOP_SUBMENU_LINK_HANDLE = 'data-desktop-submenu-link-handle';
export var CLASS_MENU_OPEN = 'is-menu-open';
export var CLASS_SUBMENU_OPEN = 'is-submenu-open';
export var CLASS_SUBSUBMENU_OPEN = 'is-subsubmenu-open';
export var CLASS_SUBSUBMENU_VISIBLE = 'is-subsubmenu-visible';
export var CLASS_VISIBLE = 'is-visible';
export var CLASS_ACTIVE = 'is-active';
export var DesktopMenu = /*#__PURE__*/function () {
  function DesktopMenu(template, container) {
    var _this = this;
    _classCallCheck(this, DesktopMenu);
    this.container = container;
    this.template = template;
    this.menuTrigger = container.find("[".concat(DESKTOP_MENU_TRIGGER, "]"));
    this.submenu = container.find("[".concat(DESKTOP_MENU_SUBMENU, "]"));
    this.submenuTriggers = container.find("[".concat(DESKTOP_SUBMENU_TRIGGER, "]"));
    this.subsubmenuContainer = container.find(DESKTOP_SUBMENU_CONTAINER);
    this.subsubmenuContent = container.find("[".concat(DESKTOP_SUBSUBMENU_CONTENT, "]"));
    this.submenuImageContent = container.find("[".concat(DESKTOP_SUBMENU_LINK_HANDLE, "]"));
    this.submenuImageContentTrigger = container.find("[".concat(DESKTOP_SUBSUBMENU_CONTENT_TRIGGER, "]"));
    this.menuInner = $(HEADER_INNER);
    container.on('click touchend', "[".concat(DESKTOP_MENU_TRIGGER, "]"), function (e) {
      return _this.onMenuTrigger(e);
    });
    container.on('click touchend', "[".concat(DESKTOP_SUBMENU_TRIGGER, "]"), function (e) {
      return _this.onSubmenuTriggerClick(e);
    });
    container.on('mouseenter', "[".concat(DESKTOP_SUBMENU_TRIGGER, "]"), function (e) {
      return _this.onSubmenuTriggerHover(e);
    });
    container.on('mouseenter', "[".concat(DESKTOP_SUBSUBMENU_CONTENT_TRIGGER, "]"), function (e) {
      return _this.onSubmenuLinkHover(e);
    });
  }
  _createClass(DesktopMenu, [{
    key: "onMenuTrigger",
    value: function onMenuTrigger(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = $(e.currentTarget);
      var handle = self.attr(DESKTOP_MENU_TRIGGER);
      var menu = this.container.find("[".concat(DESKTOP_MENU_SUBMENU, "=\"").concat(handle, "\"]"));

      //Hide self if it was already open, otherwise show new menu
      if (self.hasClass(CLASS_SUBMENU_OPEN)) {
        self.removeClass(CLASS_SUBMENU_OPEN);
        menu.removeClass(CLASS_SUBMENU_OPEN);
      } else {
        this.submenu.removeClass(CLASS_SUBMENU_OPEN);
        this.menuTrigger.removeClass(CLASS_SUBMENU_OPEN);
        self.addClass(CLASS_SUBMENU_OPEN);
        menu.addClass(CLASS_SUBMENU_OPEN);
      }

      //Do we have a menu showing? If so toggle class on container
      if (this.submenu.hasClass(CLASS_SUBMENU_OPEN)) {
        [this.container, this.menuInner].forEach(function (e) {
          return $(e).addClass(CLASS_MENU_OPEN);
        });
      } else {
        [this.container, this.menuInner].forEach(function (e) {
          return $(e).removeClass(CLASS_MENU_OPEN);
        });
      }

      //Hide all of the submenus and their elements
      if (this.subsubmenuContainer.hasClass(CLASS_SUBSUBMENU_OPEN)) {
        this.subsubmenuContainer.removeClass(CLASS_SUBSUBMENU_OPEN);
        this.submenuTriggers.removeClass(CLASS_ACTIVE);
        this.subsubmenuContent.removeClass(CLASS_SUBSUBMENU_VISIBLE);
        this.submenuImageContent.removeClass(CLASS_VISIBLE);
        this.submenuImageContentTrigger.removeClass(CLASS_ACTIVE);
      }
    }
  }, {
    key: "onSubmenuTriggerClick",
    value: function onSubmenuTriggerClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.onSubmenuTriggerHover(e);
    }
  }, {
    key: "onSubmenuTriggerHover",
    value: function onSubmenuTriggerHover(e) {
      var self = $(e.currentTarget);
      var handle = self.attr(DESKTOP_SUBMENU_TRIGGER);
      var subsubmenuContent = this.container.find("[".concat(DESKTOP_SUBSUBMENU_CONTENT, "=\"").concat(handle, "\"]"));

      //No content, don't update 
      if (!subsubmenuContent.length) return;

      //Subsubmenu content exists, update classes
      this.subsubmenuContainer.addClass(CLASS_SUBSUBMENU_OPEN);
      this.submenuTriggers.removeClass(CLASS_ACTIVE);
      self.addClass(CLASS_ACTIVE);
      this.subsubmenuContent.removeClass(CLASS_SUBSUBMENU_VISIBLE);
      subsubmenuContent.addClass(CLASS_SUBSUBMENU_VISIBLE);
      this.submenuImageContent.removeClass(CLASS_VISIBLE);
      this.submenuImageContentTrigger.removeClass(CLASS_ACTIVE);
    }
  }, {
    key: "onSubmenuLinkHover",
    value: function onSubmenuLinkHover(e) {
      var self = $(e.currentTarget);
      var handle = self.attr(DESKTOP_SUBSUBMENU_CONTENT_TRIGGER);
      var submenuImageContent = this.container.find("[".concat(DESKTOP_SUBMENU_LINK_HANDLE, "=\"").concat(handle, "\"]"));

      //No content, don't update 
      if (!submenuImageContent.length) return;

      //Submenu image content exists, update classes
      this.submenuImageContent.removeClass(CLASS_VISIBLE);
      submenuImageContent.addClass(CLASS_VISIBLE);
      this.submenuImageContentTrigger.removeClass(CLASS_ACTIVE);
      self.addClass(CLASS_ACTIVE);
    }
  }]);
  return DesktopMenu;
}();